import ShowContent from './component';

export default ShowContent;
